// extracted by mini-css-extract-plugin
export default {"authLayoutLogo":"logo_authLayoutLogo__Sh9KJ","authLogoPartOne":"logo_authLogoPartOne__jBX0f","authLogoPartTwo":"logo_authLogoPartTwo__dZEMb","mTradeLogo":"logo_mTradeLogo__YdUvp"};